import { ConfigSubdomain } from "@/shared/group-configs/config-subdomains";

/**
 * Tenants renamed in place, keyed by the subdomain they used to have. Both names must keep
 * resolving until every `group.subdomain` row, Stytch slug, and saved link has moved over.
 *
 * Lives here rather than in `configuration/` because the client bundle needs it too, and
 * `configuration/paths.ts` imports `node:path`.
 */
export const RENAMED_CONFIG_FOLDERS: Record<string, ConfigSubdomain> = {
  heartplace: ConfigSubdomain.USHV_HEARTPLACE,
  // `ushv` stays out: it is the customer subdomain, so aliasing it would redirect the portal to Heartland.
};
